

const authHeader = (multipart = false) => {

    const token = sessionStorage.getItem('token')
    const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Access-Control-Expose-Headers": "Content-Disposition",
        "Authorization": `Bearer ${token}`,
    }

    if (multipart) {
        headers["Content-Type"] = "multipart/form-data";
    }
    return headers;
}

export default authHeader